// Centralized branding configuration
// Update these values to change logos and header across the app and PDFs

import clientLogo from '../assets/client-logo.png';
import pdfLogo from '../assets/logo.png';

export const BRAND = {
  companyName: '2MP INDUSTRY SPA',
  // Dashboard/company logo (web UI)
  clientLogo,
  // PDF logo (full-width header image used at top of PDFs)
  pdfLogo,
  // PDF header location/date label
  pdfHeader: {
    city: 'BOUFARIK',
    dateLabel: 'LE :',
  },
};

export default BRAND;
